import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
body{
  font-family: "Manrope", sans-serif!important;
  background-image:url("../img/background-notaire.png");
  background-position:top center;
  background-size:cover;
}

/** colors **/
.bg-primary{background-color:${props => props.theme.colors.main}!important; color:${props => props.theme.colors.black};}
.bg-dark{background-color:${props => props.theme.colors.greenDark}!important; color:${props => props.theme.colors.white};}
.bg-secondary{background-color:${props => props.theme.colors.mainDark}!important; color:${props => props.theme.colors.white};}
/** colors tabs contact **/
.bg-vendeur{background-color:${props => props.theme.colors.main};}
.bg-acheteur{background-color:${props => props.theme.colors.blueDark};}
.bg-notaire{background-color:${props => props.theme.colors.greenDark};}
.bg-agent{background-color:${props => props.theme.colors.blueLight};}
.bg-commun{background-color:#1fb79b;}

.badge{
  padding: 0.6rem;
  font-size: 14px;
}

/** react data table **/
.rdt_TableCol{
  background-color:#F5F7FA!important;
}
.rdt_TableCell{font-size:16px!important;}
.rdt_TableCell .badge{
  padding: 0.3rem!important;
  font-size: 14px!important;
}

/** title **/
h1,h2{
  font-weight:300;
  color:#1D2B28;
  font-family: "Switzer", sans-serif;
}
h1{font-size:70px;}
h2{font-size:50px;}
h3{font-size:40px;}
h4{font-size:24px;font-weight:300;}
@media all and (max-width: 768px) {
  h1{
    font-size:40px!important;
  }
  h2{
    font-size:30px!important;
  }
}
.spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 10vh;
    width: 100vw;
    top: 50%;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .loading {
    display: flex;
    min-height: 500px;
    align-items: center;
    justify-content: center;
  }

  .textHighlight{
     font-weight: 500;
  background: linear-gradient(180deg,rgba(255,255,255,0) 50%, #1DF36C 50%);
  }

  /** tabs documents style table**/
  p.nomFiltre{
    text-transform: lowercase;
    margin-bottom:0;
  }
  p.nomFiltre::first-letter {
    text-transform: uppercase!important;
  }

 .offcanvas{
  padding:2rem;
  width:600px!important;
 }
 .depotCandidatureNotaire{
  width:100%!important;
 }

 a{cursor:pointer;}
 a.back{
  color:#000;
  align-items:center;
  margin-bottom:1rem;
  text-decoration:none;
  scg{margin-right:1rem;}
 }
  

   /** tabs **/
   .nav-pills .nav-link{
    color:#4b5563!important;
    cursor:pointer;
    &.active{
      background-color:white;
      color:${props => props.theme.colors.main}!important;
      font-weight:bold;
    }
   }

   .nav-tabs{
    .nav-item{
      
      cursor:pointer;
      a{
        color:black;
        &.active{
          background-color:#fff;
          //color:${props => props.theme.colors.mainDark}!important;
        }
      }
    }
   }
   

   /** MEMBERSTACK ELEMENT **/
   .ms-modal{
    .ms-form__button[type="submit"]{color:white;}
    h2.ms-modal__title{
      visibility: hidden;
      margin-bottom:20px
    }
    .ms-form__group{margin-bottom:10px;}
    .ms-form__input{padding:9px;}
   }
  
    #SignupModal{
    h2.ms-modal__title:after{
      content: 'Créez votre compte';
      visibility: visible;
      display: block;
      position: absolute;
      top: 6rem;
      width: 100%;
      text-align: center;
      left: 2px;
    }
    #LoginModal{
      h2.ms-modal__title:after{
        content: 'Connectez vous';
        visibility: visible;
        display: block;
        position: absolute;
        top: 6rem;
        width: 100%;
        text-align: center;
        left: 2px;
      }

    }

    /** panel notaire **/
    .card{border:0;}

   

   
   
    `



  ;



